var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:['inline-flex align-middle fill-current', _vm.classes],attrs:{"viewBox":_vm.viewBox,"width":_vm.width,"height":_vm.height,"aria-labelledby":_vm.icon,"role":"presentation"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }